<fury-page>
  <fury-title class="title">
      <h2>Create customer agreement</h2>
  </fury-title>
</fury-page>
<div fxLayout="column" fxLayoutAlign="start center">
  <div [@fadeInUp] class="card">
    <form [formGroup]="createCustomerAgreementForm">

      <div class="content" fxLayout="column" fxLayoutGap="8px">
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Select a state</mat-label>
            <mat-select (selectionChange)="getStateCode($event)" formControlName="stateId">
              <mat-option *ngFor="let item of stateList" [value]="item.stateId">
                {{ item.title }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['stateId'].touched &&
                createCustomerAgreementForm.controls['stateId'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>State code</mat-label>
            <input type="text" matInput placeholder="State code" formControlName="stateCode" readonly />
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['stateCode'].touched &&
                createCustomerAgreementForm.controls['stateCode'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <div class="tirdwidth">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Agreement number</mat-label>
  
              <input matInput placeholder="Agreement number" formControlName="agreementNumber" [readonly]="versionId ? true : false " />
              <mat-error *ngIf="
                  createCustomerAgreementForm.controls['agreementNumber']
                    .touched &&
                  createCustomerAgreementForm.controls[
                    'agreementNumber'
                  ].hasError('required')
                ">
                This field is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="tirdwidth">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Agreement version</mat-label>
  
              <input readonly matInput placeholder="Agreement version" [value]="versionNo" />
            </mat-form-field>
          </div>
          <div class="tirdwidth">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Agreement purchase date</mat-label>
  
              <input matInput placeholder="Agreement purchase date" formControlName="agreementPurchaseDate"
              min="{{date | date:'yyyy-MM-dd'}}"
                type="date" />
              <mat-error *ngIf="
                  createCustomerAgreementForm.controls[
                    'agreementPurchaseDate'
                  ].touched &&
                  createCustomerAgreementForm.controls[
                    'agreementPurchaseDate'
                  ].hasError('required')
                ">
                This field is required.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Enter First name</mat-label>
            <input matInput placeholder="First Name" formControlName="firstName" />
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['firstName'].touched &&
                createCustomerAgreementForm.controls['firstName'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Enter Last name</mat-label>
            <input matInput placeholder="Last Name" formControlName="lastName" />
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['lastName'].touched &&
                createCustomerAgreementForm.controls['lastName'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Enter Phone number</mat-label>
            <input type="text" matInput placeholder="Phone number" formControlName="phoneNumber"
              mask="(000) 000-0000" />
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['phoneNumber']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'phoneNumber'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['phoneNumber']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'phoneNumber'
                ].hasError('pattern')
              ">
              Invalid phone number.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Enter Email address</mat-label>
            <input matInput placeholder="Email address" formControlName="emailAddress" />
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['emailAddress']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'emailAddress'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['emailAddress']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'emailAddress'
                ].hasError('pattern')
              ">
              Invalid email address.
            </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Enter Property address</mat-label>
          <input #location matInput placeholder="Property address" formControlName="streetAddress"  />
          <mat-error *ngIf="
              !createCustomerAgreementForm.get(
                'propertyAddress.streetAddress'
              )!.valid &&
              createCustomerAgreementForm.get(
                'propertyAddress.streetAddress'
              )!.touched
            ">
            This field is required.
          </mat-error>
        </mat-form-field>

        <div>
          <b>
            <input [checked]="isShowUnitNo" type="checkbox" (change)="unitNoChange()" />
            Are you add your unit number?
          </b>
        </div>
      
          <mat-form-field style="width: 50%;" appearance="outline" *ngIf="isShowUnitNo">
            <mat-label>Unit Number</mat-label>
            <input type="number" matInput placeholder="Unit number" formControlName="unitNumber" />
            <mat-error *ngIf="
                !createCustomerAgreementForm.get(
                  'propertyAddress.unitNumber'
                )!.valid &&
                createCustomerAgreementForm.get(
                  'propertyAddress.unitNumber'
                )!.touched
              ">
              This field is required.
            </mat-error>
          </mat-form-field>

          <div class="property_select">
            <h3>Select property type</h3>
            <ul>
              <li *ngFor="let item of propertyTypeList">
                <input type="radio" [value]="item.planPropertyTypeId" formControlName="planPropertyTypeId" />
                <label>{{ item.title }}</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['planPropertyTypeId']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'planPropertyTypeId'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
          </div>
          <div class="property_select">
            <h3>Select property size</h3>
            <ul>
              <li *ngFor="let item of propertySizeList">
                <input type="radio" [value]="item.planPropertySizeId" formControlName="planPropertySizeId" />
                <label>{{ item.title }}</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['planPropertySizeId']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'planPropertySizeId'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
          </div>
  
          <div class="property_select">
            <h3>Select a plan</h3>
            <ul>
              <li *ngFor="let mainPlan of mainPlans">
                <input type="radio" formControlName="mainPlanId" [value]="mainPlan.planOptionalItemCategoryId"
                   />
                <label>{{ mainPlan["title"] }}</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['mainPlanId'].touched &&
                createCustomerAgreementForm.controls['mainPlanId'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </div>

          <div class="plan-itembox" *ngIf="mainPlanCoverItemList.length > 0">
            <span *ngFor="let item of mainPlanCoverItemList">
              <input type="checkbox" [checked]="item?.isChecked"
                (change)="mainCoverItemChange($event, item.planCoverItemId)" />
              {{ item.title }}
            </span>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['mainPlanItems']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'mainPlanItems'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
          </div>
  
          <div class="property_select">
            <h3>Select a optional items</h3>
            <ul>
              <li *ngFor="let optionalPlan of optionaalPlans">
                <input type="radio" formControlName="optionalPlanId"
                  [value]="optionalPlan?.planOptionalItemCategoryId" />
                <label>{{ optionalPlan["title"] }}</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['optionalPlanId']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'optionalPlanId'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
          </div>
  
          <div class="plan-itembox" *ngIf="optionalPlanCoverItemList.length > 0">
            <span *ngFor="let item of optionalPlanCoverItemList">
              <input type="checkbox" [checked]="item.isChecked" (change)="
                  optionalCoverItemChange($event, item.planCoverItemId)
                " />
              {{ item.title }}
            </span>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['optionalPlanItems']
                  .touched &&
                createCustomerAgreementForm.controls[
                  'optionalPlanItems'
                ].hasError('required')
              ">
              This field is required.
            </mat-error>
          </div>
  
          <div class="property_select">
            <h3>Select a service fee</h3>
            <ul>
              <li>
                <input type="radio" [value]="70" formControlName="serviceFee" />
                <label>$70.00</label>
              </li>
              <li>
                <input type="radio" [value]="100" formControlName="serviceFee" />
                <label>$100.00</label>
              </li>
              <li>
                <input type="radio" [value]="130" formControlName="serviceFee" />
                <label>$130.00</label>
              </li>
              <li>
                <input type="radio" [value]="0" formControlName="serviceFee" />
                <label>$0</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['serviceFee'].touched &&
                createCustomerAgreementForm.controls['serviceFee'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </div>
  
          <div class="property_select">
            <h3>Select coverage term</h3>
            <ul>
              <li>
                <input type="radio" value="Monthly" formControlName="coverageTerm" />
                <label>Monthly</label>
              </li>
              <li>
                <input type="radio" value="1 Year" formControlName="coverageTerm" />
                <label>1 Year</label>
              </li>
              <li>
                <input type="radio" value="2 Years" formControlName="coverageTerm" />
                <label>2 Years</label>
              </li>
              <li>
                <input type="radio" value="3 Years" formControlName="coverageTerm" />
                <label>3 Years</label>
              </li>
              <li>
                <input type="radio" value="5 Years" formControlName="coverageTerm" />
                <label>5 Years</label>
              </li>
            </ul>
            <mat-error *ngIf="
                createCustomerAgreementForm.controls['coverageTerm']
                  .touched &&
                createCustomerAgreementForm.controls['coverageTerm'].hasError(
                  'required'
                )
              ">
              This field is required.
            </mat-error>
          </div>
          <div class="property_select" *ngIf="
              createCustomerAgreementForm.value?.coverageTerm !== 'Monthly' && createCustomerAgreementForm.value?.coverageTerm
            ">
            <h3>Select Free Month</h3>
            <ul>
              <li>
                <input type="radio" value="1 Month" formControlName="freeMonth" />
                <label>1 Month</label>
              </li>
              <li>
                <input type="radio" value="2 Months" formControlName="freeMonth" />
                <label>2 Months</label>
              </li>
              <li>
                <input type="radio" value="3 Months" formControlName="freeMonth" />
                <label>3 Months</label>
              </li>
              <li>
                <input type="radio" value="4 Months" formControlName="freeMonth" />
                <label>4 Months</label>
              </li>
              <li>
                <input type="radio" value="5 Months" formControlName="freeMonth" />
                <label>5 Months</label>
              </li>
              <li>
                <input type="radio" value="6 Months" formControlName="freeMonth" />
                <label>6 Months</label>
              </li>
            </ul>
          </div>
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
            <div class="tirdwidth">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Waiting period</mat-label>
                <input type="number" matInput placeholder="Waiting period" formControlName="waitingPeriod" />
                <mat-error *ngIf="
                    createCustomerAgreementForm.controls['waitingPeriod']
                      .touched &&
                    createCustomerAgreementForm.controls[
                      'waitingPeriod'
                    ].hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="tirdwidth">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Start date</mat-label>
                <input matInput formControlName="startDate" placeholder="Start date" type="date"
                  readonly />
              </mat-form-field>
            </div>
            <div class="tirdwidth">
              <div *ngIf="
              createCustomerAgreementForm.value?.coverageTerm !== 'Monthly'
            ">
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Expiration date</mat-label>
                  <input matInput formControlName="endDate" placeholder="Expiration date" type="date"
                    readonly />
                </mat-form-field>
            </div>
            </div>
          </div>

          <div>
            <b>
              <input [checked]="isSameMailingAddress" (change)="checkSameMailAddress()" type="checkbox" />
              Mailing address same as property address
            </b>
          </div>
  
          <div class="input_field fullwidth" formGroupName="mailingAddress" *ngIf="!isSameMailingAddress">
            <mat-form-field style="width:100%" appearance="outline">
              <mat-label>Enter Mailing address</mat-label>
              <input #mailingAddress matInput placeholder="Mailing address" formControlName="streetAddress" />
              <mat-error *ngIf="
                  !createCustomerAgreementForm.get(
                    'mailingAddress.streetAddress'
                  )!.valid &&
                  createCustomerAgreementForm.get(
                    'mailingAddress.streetAddress'
                  )!.touched
                ">
                This field is required.
              </mat-error>
            </mat-form-field>
            <div class="unit_area" *ngIf="!isSameMailingAddress">
              <div>
                <b>
                  <input [checked]="isShowMailingUnitNo" type="checkbox" (change)="mailingUnitNoChange()" />
                  Are you add your unit number?
                </b>
              </div>
  
              <div class="input_field" *ngIf="isShowMailingUnitNo">
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Unit Number</mat-label>
                  <input type="number" matInput placeholder="Unit number" formControlName="unitNumber" />
                  <mat-error *ngIf="
                      !createCustomerAgreementForm.get(
                        'mailingAddress.unitNumber'
                      )!.valid &&
                      createCustomerAgreementForm.get(
                        'mailingAddress.unitNumber'
                      )!.touched
                    ">
                    This field is required.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>


          <ng-container *ngIf="createCustomerAgreementForm.get('coverageTerm')?.value">
            <div class="aboutpaymentdetail">
              <h3>About payment</h3>

              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                <div class="tirdwidth">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Agreement price</mat-label>
                    <input type="number" (ngModelChange)="getTotalCostChange()" matInput placeholder="Agreement price"
                      formControlName="agreementPrice" />
                    <mat-error *ngIf="
                      createCustomerAgreementForm.controls['agreementPrice']
                        .touched &&
                      createCustomerAgreementForm.controls[
                        'agreementPrice'
                      ].hasError('required')
                    ">
                      This field is required.
                    </mat-error>
                    <mat-error *ngIf="createCustomerAgreementForm.controls['agreementPrice'].hasError('min')">
                      Agreement price amount is invalid.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="tirdwidth">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Surcharge</mat-label>
                    <input type="number" (ngModelChange)="getTotalCostChange()" matInput placeholder="Surcharge"
                      formControlName="surchargeAmount" />
                    <mat-error *ngIf="
                      createCustomerAgreementForm.controls['surchargeAmount']
                        .touched &&
                      createCustomerAgreementForm.controls[
                        'surchargeAmount'
                      ].hasError('required')
                    ">
                      This field is required.
                    </mat-error>
                    <mat-error *ngIf="createCustomerAgreementForm.controls['surchargeAmount'].hasError('min')">
                      Surcharge amount is invalid.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="tirdwidth">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Total Cost</mat-label>
                    <input type="number" readonly matInput placeholder="Total Cost" formControlName="totalCost" />
                    <mat-error *ngIf="createCustomerAgreementForm.controls['totalCost'].hasError('min')">
                      Total cost amount is invalid.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              
  
              <ng-container *ngIf="createCustomerAgreementForm.get('totalCost')?.value">
                <div class="property_select">
                  <h3>Select Payment Type</h3>
                  <ul *ngIf="
                  createCustomerAgreementForm.value?.coverageTerm !==
                  'Monthly'
                ">
                    <li>
                      <input type="radio" value="Full Payment" formControlName="paymentType" />
                      <label>Full Payment</label>
                    </li>
                    <li>
                      <input type="radio" value="2 Payments" formControlName="paymentType" />
                      <label>2 Payments</label>
                    </li>
                    <li>
                      <input type="radio" value="3 Payments" formControlName="paymentType" />
                      <label>3 Payments</label>
                    </li>
                    <li>
                      <input type="radio" value="4 Payments" formControlName="paymentType" />
                      <label>4 Payments</label>
                    </li>
                    <li>
                      <input type="radio" value="5 Payments" formControlName="paymentType" />
                      <label>5 Payments</label>
                    </li>
                    <li>
                      <input type="radio" value="6 Payments" formControlName="paymentType" />
                      <label>6 Payments</label>
                    </li>
                  </ul>
                  <ul *ngIf="
                  createCustomerAgreementForm.value?.coverageTerm ===
                  'Monthly'
                ">
                    <li>
                      <input type="radio" value="Monthly" formControlName="paymentType" />
                      <label>Monthly</label>
                    </li>
                  </ul>
                  <mat-error *ngIf="
                  createCustomerAgreementForm.controls['paymentType']
                    .touched &&
                  createCustomerAgreementForm.controls[
                    'paymentType'
                  ].hasError('required')
                ">
                    This field is required.
                  </mat-error>
                </div>
  
                <h4>
                  <b> Payment details </b>
                </h4>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px" style="flex-wrap:wrap;">
                  <div class="fouthwidth">
                    <mat-form-field appearance="outline">
                      <mat-label>Total Paid</mat-label>
                      <input [readonly]="createCustomerAgreementForm.value?.coverageTerm === 'Monthly'" type="number"
                        matInput formControlName="downPaymentAmount" placeholder="Total Paid" />
                      <mat-error *ngIf="createCustomerAgreementForm.controls['downPaymentAmount'].hasError('min')">
                        Total Paid amount is invalid.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="fouthwidth" *ngIf="createCustomerAgreementForm.value?.coverageTerm !== 'Monthly'">
                    <mat-form-field appearance="outline">
                      <mat-label>Remaining Balance</mat-label>
                      <input readonly type="number" matInput placeholder="Remaining Balance"
                        formControlName="remainingBalance" />
                    </mat-form-field>
                  </div>
                  <div class="fouthwidth">
                    <mat-form-field appearance="outline">
                      <mat-label>Method</mat-label>
                      <mat-select formControlName="paymentMethod">
                        <mat-option value="credit-debit-card">
                          Credit/debit card
                        </mat-option>
  
                        <mat-option value="escrow-invoice" *ngIf="
                        createCustomerAgreementForm.value?.coverageTerm !==
                        'Monthly'
                      ">
                          Escrow Invoice
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="
                      createCustomerAgreementForm.controls['paymentMethod']
                        .touched &&
                      createCustomerAgreementForm.controls[
                        'paymentMethod'
                      ].hasError('required')
                    ">
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="fouthwidth" *ngIf="
                  createCustomerAgreementForm.value.paymentMethod !==
                  'escrow-invoice'
                ">
                    <mat-form-field appearance="outline">
                      <mat-label>Payment information</mat-label>
                      <input matInput placeholder="Payment information" formControlName="paymentInformation" />
                    </mat-form-field>
                  </div>
                  <div class="fouthwidth" *ngIf="
                  createCustomerAgreementForm.value.paymentMethod ===
                  'escrow-invoice'
                ">
                    <mat-form-field appearance="outline">
                      <mat-label>Escrow due date </mat-label>

                      <input matInput placeholder="Agreement purchase date" formControlName="escrowDueDate" min="{{date | date:'yyyy-MM-dd'}}"
                        type="date" />
                    </mat-form-field>
                  </div>

                  <div class="fouthwidth" *ngIf="
                  createCustomerAgreementForm.value.coverageTerm ===
                  'Monthly'
                ">
                    <mat-form-field appearance="outline">
                      <mat-label>Day of payment </mat-label>
  
                      <input matInput type="number" readonly="" placeholder="Day of monthly paymet" formControlName="dayOfMonthlyPayment" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- <div style="display: flex; flex-wrap: wrap">
                  <div class="input_field">
                   
                  </div>
                  <div class="input_field" *ngIf="createCustomerAgreementForm.value?.coverageTerm !== 'Monthly'">
                    
                  </div>
                  <div class="input_field">
                    
                  </div>
                  <div class="input_field" *ngIf="
                  createCustomerAgreementForm.value.paymentMethod !==
                  'escrow-invoice'
                ">
                    
                  </div>
                  <div class="input_field" *ngIf="
                  createCustomerAgreementForm.value.paymentMethod ===
                  'escrow-invoice'
                ">
                    
                  </div>
                  <div class="input_field" *ngIf="
                  createCustomerAgreementForm.value.coverageTerm ===
                  'Monthly'
                ">
                    <mat-form-field style="width: 30%" appearance="outline">
                      <mat-label>Day of payment </mat-label>
  
                      <input matInput type="number" readonly="" placeholder="Day of monthly paymet" formControlName="dayOfMonthlyPayment" />
                    </mat-form-field>
                  </div>
                </div> -->
  
                <div class="upcomingpayment" *ngIf="
                createCustomerAgreementForm.value?.coverageTerm !==
                  'Monthly' &&
                createCustomerAgreementForm.value.paymentType !==
                  'Full Payment'
              ">
                  <h4>Upcoming payment</h4>
  
                  <div>
                    <div formArrayName="upcomingPayments"
                      *ngFor="let child of createCustomerAgreementForm.get('upcomingPayments')?.controls; let formGroupIndex=index">
  
                      <div class="upcomingpaymentlist" [formGroupName]="formGroupIndex">
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px" style="flex-wrap:wrap;">
                          <div class="fouthwidth">
                            <mat-form-field appearance="outline">
                              <mat-label>Ammout paid</mat-label>
                              <input type="number" matInput placeholder="Remaining Balance" [readonly]="child?.value?.amountPaid === 0"
                                (ngModelChange)="changeAmountPaid(formGroupIndex, child)" formControlName="amountPaid" />
                            </mat-form-field>
                          </div>
                          <div class="fouthwidth">
                            <mat-form-field appearance="outline">
                              <mat-label>Remaining Balance</mat-label>
                              <input readonly type="number" matInput formControlName="remainingBalance" 
                                placeholder="Remaining Balance" />
                            </mat-form-field>
                          </div>
                          <div class="fouthwidth">
                            <mat-form-field appearance="outline">
                              <mat-label>Method</mat-label>
                              <mat-select formControlName="paymentMethod" [disabled]="child?.value?.amountPaid === 0">
                                <mat-option value="credit-debit-card">
                                  Credit/debit card
                                </mat-option>
      
                                <mat-option value="escrow-invoice">
                                  Escrow Invoice
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="fouthwidth">
                            <mat-form-field appearance="outline">
                              <mat-label>Due date</mat-label>
                              <input matInput placeholder="due date" type="date" formControlName="dueDate" [readonly]="child?.value?.amountPaid === 0" />
                            </mat-form-field>
                          </div>
                        </div>
                        
                       
  
                        
  
                       
                      </div>
                    </div>
                  </div>
                </div>
  
                <p>
                  <b> No additional payments are due. </b>
                </p>
              </ng-container>
  
            </div>
  
          </ng-container>
        
      </div>

      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
        <button mat-button type="button" class="sub-button" (click)="createAgreement()">{{versionId ? "UPDATE" : "ADD"}}</button>
        
      </div>
      <div class="agreement-box">
       

       

        
        <!-- <div formGroupName="propertyAddress">
          <div class="input_field fullwidth">
            
          </div>
          <div class="unit_area">
            

            <div class="input_field" *ngIf="isShowUnitNo">
             
            </div>
          </div>
        </div> -->

        

       

        
        <!-- <div class="fullwidthprt">
          <div class="input_field">
            
          </div>

          <div class="input_field">
            
          </div>
         
        </div> -->

       

       

        <!-- <div class="form-fld text-center" style="margin-top: 16px">
          <div class="actionControl">
            <button type="button" class="submit-btn" (click)="createAgreement()">
             {{versionId ? "UPDATE" : "ADD"}}
            </button>
          </div>
        </div> -->
      </div>
    </form>
  </div>
</div>


